import { X } from "lucide-react";

// Full-viewport Vaulzo modal shell: warm canvas + fixed red circular close.
// Offsets respect iOS safe areas (--safe-top/--safe-bottom from index.css):
// in the installed PWA the app draws edge-to-edge, so without them the close
// button hides under the Dynamic Island and the footer under the home bar.
export default function FullScreenModal({ open, onClose, children }) {
  if (!open) return null;
  return (
    <div className="fixed inset-0 z-[100] flex flex-col bg-vaulzo-bg animate-vz-fade">
      <button
        onClick={onClose}
        title="Close"
        aria-label="Close"
        className="fixed right-[18px] top-[calc(14px+var(--safe-top))] z-10 flex h-[42px] w-[42px] items-center justify-center rounded-full bg-vaulzo-close-red text-vaulzo-on-fill transition-opacity hover:opacity-[0.55] sm:right-[26px] sm:top-[calc(22px+var(--safe-top))]"
      >
        <X className="h-[19px] w-[19px]" strokeWidth={2.4} />
      </button>
      <div className="flex flex-1 justify-center overflow-y-auto px-6 pb-[calc(64px+var(--safe-bottom))] pt-[calc(72px+var(--safe-top))] sm:pt-[calc(96px+var(--safe-top))]">
        {children}
      </div>
    </div>
  );
}
